import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalVideoComponent } from '../components/modal-video/modal-video.component';
import { GenericMessageModalProperties } from '@utilities/components/generic-message-modal/generic-message-modal-properties.interface';
import { GenericMessageModalComponent } from '@utilities/components/generic-message-modal/generic-message-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { httpErrorResponseToText } from '@utilities/functions/http-error-response-to-text';
import { Router, TitleStrategy } from '@angular/router';
import { WishlistItemAddedModalComponent } from '../components/wishlist-item-added-modal/wishlist-item-added-modal.component';
import { Catalog } from '../../rewards/interfaces/search-catalog-response.interface';
import { CreateNewWishlistModalComponent } from '../components/create-new-wishlist-modal/create-new-wishlist-modal.component';
import { ModalOrdersByConfirmComponent } from '../../home/components/modal-orders-by-confirm/modal-orders-by-confirm.component';
import { GetOrdersByConfirmResponse } from '../../home/interfaces/get-orders-by-confirm.response';
import { ModalSharedComponent } from '../components/modal-shared/modal-shared.component';
import { httpTitleResponseToText } from '@utilities/functions/http-title-response-to-text';
import { catchError, from, map, of } from 'rxjs';
import { SharedWishlistItemAddedModalComponent } from '../components/sharedwishlist-item-added-modal/sharedwishlist-item-added-modal.component';
import { VerifiedSharedWishListModalComponent } from '../components/verified-shared-wishlist.modal/verified-shared-wishlist.modal.component';
import { CreateNewWishlistOnlyModalComponent } from '../components/create-new-wishlist-only-modal/create-new-wishlist-only-modal.component';
import { ChallengeResponse } from '../interfaces/challenge-response.interface';
import { ModalMechanicsComponent } from '../components/modal-mechanics/modal-mechanics.component';
import { MissionQuizModalComponent } from '../../missions/modals/mission-quiz-modal/mission-quiz-modal.component';
import { MissionSuccessModalComponent } from '../../missions/modals/mission-success-modal/mission-success-modal.component';
import { BenefitsResponse } from '../interfaces/benefits-response.interface';
import { ModalRemainingPointsComponent } from '../components/modal-remaining-points/modal-remaining-points.component';
import { ModalVideoHomeComponent } from '../components/modal-video-home/modal-video-home.component';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private ngbModal = inject(NgbModal);
  private router = inject(Router);

  openModalVideo() {
    this.ngbModal.open(ModalVideoComponent, {
      centered: true,
    });
  }

  openModalVideoHome() {
    this.ngbModal.open(ModalVideoHomeComponent, {
      centered: true,
    });
  }

  openGenericModal(properties: GenericMessageModalProperties) {
    const modal = this.ngbModal.open(GenericMessageModalComponent, {
      centered: true,
    });
    modal.componentInstance.properties.set(properties);
  }

  showErrorModal(err: HttpErrorResponse) {
    this.ngbModal
      .open(GenericMessageModalComponent, {
        centered: true,
      })
      .componentInstance.properties.set({
        title: httpTitleResponseToText(err),
        body: httpErrorResponseToText(err),
      } as GenericMessageModalProperties);
  }

  addArticleSuccess() {
    this.openGenericModal({
      title: '¡ARTÍCULO AGREGADO EXITOSAMENTE!',
      body: 'Continúa con tu compra.',
      buttons: [
        {
          label: 'Ver carrito',
          styleClass: 'perfilbtn-pep',
          action: () => this.router.navigate(['/cart']),
        },
      ],
    });
  }

  saveArticleInWishList(article: Catalog, wishList: string) {
    const modalRef = this.ngbModal.open(WishlistItemAddedModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.article.set(article);
    modalRef.componentInstance.wishList.set(wishList);
  }

  saveArticleInSharedWishList(article: Catalog) {
    const modalRef = this.ngbModal.open(SharedWishlistItemAddedModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.article.set(article);
  }

  createNewWishList(article: Catalog) {
    const modalRef = this.ngbModal.open(CreateNewWishlistModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.article.set(article);
  }

  createNewWishListOnly() {
    const modalRef = this.ngbModal.open(CreateNewWishlistOnlyModalComponent, {
      centered: true,
    });
  }

  ordersByConfirm(ordersByConfirm: GetOrdersByConfirmResponse[]) {
    const modalRef = this.ngbModal.open(ModalOrdersByConfirmComponent, {
      centered: true,
    });
    modalRef.componentInstance.ordersByConfirm.set(ordersByConfirm);
  }

  sharedResourceByEmail(
    title: string,
    description: string,
    wishListId: string,
  ) {
    const modalRef = this.ngbModal.open(ModalSharedComponent, {
      centered: true,
    });
    modalRef.componentInstance.title.set(title);
    modalRef.componentInstance.description.set(description);
    modalRef.componentInstance.wishListId.set(wishListId);
    return from(modalRef.result).pipe(
      map((result) => !!result), 
      catchError(() => of(false)),
    );
  }

  VerifiedSharedWishList(name: string) {
    const modalRef = this.ngbModal.open(VerifiedSharedWishListModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.name.set(name);
  }

  openMechanics(challenge: ChallengeResponse) {
    const ref = this.ngbModal.open(ModalMechanicsComponent, { centered: true });
    ref.componentInstance.challenge.set(challenge);
    return ref;
  }

  openChallengeQuiz(challenge: ChallengeResponse) {
    const ref = this.ngbModal.open(MissionQuizModalComponent, {
      centered: true,
    });
    ref.componentInstance.challenge.set(challenge);
    return ref;
  }

  openSuccessMission(message: string) {
    const modalRef = this.ngbModal.open(MissionSuccessModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.message.set(message);
  }

  openRemainigPoints() {
    const modalRef = this.ngbModal.open(ModalRemainingPointsComponent, {
      centered: true,
    });
  }
}
